import { render, staticRenderFns } from "./input_sk_kolektif_pembetulan.vue?vue&type=template&id=2ace6f82&"
import script from "./input_sk_kolektif_pembetulan.vue?vue&type=script&lang=js&"
export * from "./input_sk_kolektif_pembetulan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports